// extracted by mini-css-extract-plugin
module.exports = {"surface":"e42pk","menu":"pumcr","item":"LiwNz","link":"-zpSx","active":"_8I+aB","label":"_6zMys","icon":"LWYCB"};